// Campus photo for /colleges/macalester-college: CC BY-SA 3.0, by Evenjk, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AOld_Main-Macalester.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/macalester-college/; credited under the photo.
const photo = {
    "slug": "macalester-college",
    "alt": "Old Main, the red brick hall behind a green lawn and autumn trees at Macalester College in Saint Paul, Minnesota",
    "src": "/colleges/macalester-college/campus-1600.webp",
    "srcSmall": "/colleges/macalester-college/campus-800.webp",
    "srcMid": "/colleges/macalester-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/macalester-college/og.jpg",
    "title": "Old Main-Macalester",
    "author": "Evenjk",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AOld_Main-Macalester.jpg",
    "read": "2026-10-02"
};

export default photo;
